import { TimetableDepartureResponse } from "@/models/api/TimetableDepartureResponse";
import { ModeOfTravelEnum } from "@/models/enums";
import { TimetableDeparture } from "@/models/www/TimetableDeparture";
import axios from "axios";
import useRuntimeConfig from '@/composables/useRuntimeConfig';
import baseApi from "./api.service";

const timetableService = {
    get(travelType: ModeOfTravelEnum, route: string, startDate: string): Promise<TimetableDeparture[]> {
        return baseApi.get<TimetableDepartureResponse[]>(`timetable/${travelType}/${route}/${startDate}`).then(r => r.map(d => new TimetableDeparture(d)))
    },
    getMaxMonth() {
    		const { getRuntimeConfig } = useRuntimeConfig();
    		
    		return new Promise<number>((resolve) => {
					getRuntimeConfig()
  	      .then(x => (axios.get<number>(`${x.apiBaseUrl}timetable/max`))
  	      								 .then(resp => resolve(resp.data)));// use axios directly to avoid error-message if endpoint not found
  	    });
    }
}

export default timetableService;